<template>
  <v-card :elevation="elevation" outlined tile :loading="loading">
    <v-list-item three-line>
      <v-list-item-content>
        <v-list-item-subtitle>
          <v-icon class="mx-2" :color="iconColor" dark>{{icon}}</v-icon>
          {{title}}
        </v-list-item-subtitle>
        <v-list-item-title class="title mb-1">{{text}}</v-list-item-title>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              absolute
              fab
              outlined
              x-small
              top
              right
              color="secondary"
              elevation="0"
              v-on="on"
              @click="refresh"
            >
              <v-icon>mdi-cached</v-icon>
            </v-btn>
          </template>
          <span>Obnoviť</span>
        </v-tooltip>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    bgColor: {
      type: String,
      default: "white"
    },
    color: {
      type: String,
      default: "secondary"
    },
    elevation: {
      type: [Number, String],
      default: 0
    },
    inline: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    offset: {
      type: [Number, String],
      default: 24
    },
    title: {
      type: String,
      default: undefined
    },
    text: {
      default: undefined
    },
    icon: {
      default: ""
    },
    iconColor: {
      default: "primary"
    }
  },
  methods: {
    refresh() {
      this.$emit("refresh");
    }
  }
};
</script>